// extracted by mini-css-extract-plugin
module.exports = {"root":"_162Z4","img":"_3Ivra","buttons":"_1PMNw","title":"_2YNui","titleLink":"koK2S"};